






























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BTableColumn from "@/models/base/BTableColumn.model";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";
import moment from "moment";
import { AxiosResponse } from "axios";
import Persona from "@/models/persona/persona.model";
import { RowTable } from "@/typings/BRowTable";
import Direccion from "@/models/direccion.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import DireccionComponent from "@/components/direccion/direccion.vue";
@Component
export default class DireccionTable extends GenericBTable<PersonaDireccion> {
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public personaId!: number;
  @Prop() public cedula!: string;

  @Prop() public aggregable!: boolean;
  @Prop() public selectable!: boolean;
  @Prop() public checkable!: boolean;
  @Prop() public title!: string;
  @Prop() public hideHeader!: string;

  direcciones: Direccion[] = [];
  data: Direccion[] = [];

  get isMobile() {
    return this.$store.state.isMobile;
  }

  created() {
    this.tableConfig.controller = this.controller || "personadireccion";
    this.tableConfig.selectable = this.selectable;
    this.tableConfig.checkable = this.checkable;
    this.tableConfig.activeActions = false;
    this.tableConfig.whereParams = this.getWhereParams();

    this.tableConfig.loading = false;
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.pagination.perPage = 20;
    this.formatColumns();
  }

  getWhereParams() {
    let result = [];
    this.tableConfig.include =
      "Direccion.Barrio|Direccion.Municipio|Direccion.Provincia";
    if (this.cedula) {
      result.push(`Persona.cedula="${this.cedula}"`);
      this.tableConfig.include += "|Persona";
    } else if (this.personaId) result.push(`personaId=${this.personaId}`);
    return result.join("&");
  }

  formatColumns() {
    let direccion = new BTableColumn("direccionCorta", "Dirección", false);
    this.tableConfig.insertColumns(direccion);
  }
  adding = false;
  direccionAdd = new Direccion();
  showModalAddDireccion() {
    this.closeAdd();
    this.adding = true;
  }
  savingAdd = false;
  public async onAdd() {
    let ref = this.$refs.direccion_add as DireccionComponent;
    let isValid = await ref.isValid();
    if (!isValid) return;

    this.savingAdd = true;
    let model = new PersonaDireccion();
    model.personaId = this.personaId;
    model.direccion = this.map<PersonaDireccion>(this.direccionAdd);

    let nuevaDireccion = await this.repository.create(model);
    this.savingAdd = false;

    this.$emit("add", nuevaDireccion);
    if (this.tableConfig.reload) {
      this.tableConfig.reload(
        () =>{
          let added = this.tableConfig.data.find(x => x.id === nuevaDireccion.id) as Direccion;
          this.onSelect(added, new Direccion())
        }
      );
    }
    this.adding = false;
  }
  closeAdd() {
    this.adding = false;
  }
  public onCheck(list: Direccion[], current: Direccion) {
    this.$emit("check", list, current);
  }
  get headerTitle() {
    return this.title || "Listado de direcciones";
  }
  get hasPersona() {
    return !!this.cedula || !!this.personaId;
  }

  onSelect(selected: Direccion, old: Direccion) {
    if(this.tableConfig.selectable && this.tableConfig.selection.selected != selected){
      this.tableConfig.selection.selected = selected;
    }
    this.$emit("select", selected, old);
  }
  rowsChange(direcciones: Direccion[]) {
    this.direcciones = direcciones;
    this.$emit("direcciones", direcciones);
  }
  onLoad(response: AxiosResponse) {
    this.data = response.data || [];
    this.$emit("total-direcciones", this.data);
  }

  @Watch("cedula")
  onCedulaChange(
    value: string | undefined | null,
    old: string | undefined | null
  ) {
    if (!value) {
      this.direcciones = [];
      this.data = [];
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();

    if (this.tableConfig.reload && old) this.tableConfig.reload();
  }

  @Watch("personaId")
  onPersonaIdChange(
    value: number | undefined | null,
    old: string | undefined | null
  ) {
    if (!value) {
      this.direcciones = [];
      this.data = [];
      return;
    }
    this.tableConfig.whereParams = this.getWhereParams();

    if (this.tableConfig.reload && old) this.tableConfig.reload();
  }
}
